/**
 * APP: Taako.
 *
 * Grass container
 * Currently only mounts 2 layers and blurs the first one.
 * Only uses the 1 texture.
 *
 */

import React from 'react';
import { TilingSprite, Container } from '@inlet/react-pixi';
// import * as PIXI from 'pixi.js'

export class GrassContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sw: 0,
      sh: 0,
      ready: true,
      grassLayer1Blur: 0,
      grassLayer2Blur: 2,
      grassLayer1Offset: 0,
      grassLayer2Offset: 0,
      masterHeightOffset: 0
    }
  }

  // Used for blocking parent redraws to PIXI
  static getDerivedStateFromProps(nextProps, prevState) {
    if ( prevState.sw !== nextProps.screen.sw ||
         prevState.sh !== nextProps.screen.sh ) {
      return {
        sw: nextProps.screen.sw,
        sh: nextProps.screen.sh
      };
    }
    if ( prevState.grassLayer1Blur !== nextProps.grassData.layer_1.blur ) {
      return {
        grassLayer1Blur: nextProps.grassData.layer_1.blur
      };
    }
    if ( prevState.grassLayer2Blur !== nextProps.grassData.layer_2.blur ) {
      return {
        grassLayer2Blur: nextProps.grassData.layer_2.blur
      };
    }
    if ( prevState.grassLayer1Offset !== nextProps.grassData.layer_1.offsetY ) {
      return {
        grassLayer1Offset: nextProps.grassData.layer_1.offsetY
      };
    }
    if ( prevState.grassLayer2Offset !== nextProps.grassData.layer_2.offsetY ) {
      return {
        grassLayer2Offset: nextProps.grassData.layer_2.offsetY
      };
    }
    return null;
  }

  // Not animating yet.
  shouldComponentUpdate(nextProps, nextState) {

    if ( this.state !== nextState ) {
      // make grass height dynamic
      if ( this.state.sw !== nextProps.screen.sw ||
           this.state.sh !== nextProps.screen.sh ) {
          this.updateGrassHeight()
      }

      return true
    } else {
      return false
    }
  }

  updateGrassHeight = () => {
    this.setState({
      masterHeightOffset: ( this.state.sw < 500 && this.state.sh < 800 ) ? 60 : 0
    })
  }

  render() {
    return (
      <Container y={this.state.masterHeightOffset}>
        {/* Mountains */}
        <TilingSprite texture={this.props.texture[3]}
                      width={this.state.sw}
                      height={ 205 }
                      scale={[1,1]}
                      alpha={1}
                      anchor={[0,0]}
                      x={0}
                      y={this.state.sh - 205}/>

        {/* Grass Far */}
        <TilingSprite texture={this.props.texture[2]}
                      width={this.state.sw}
                      height={ 321 }
                      scale={[1,1]}
                      alpha={1}
                      anchor={[0,0]}
                      x={0}
                      y={this.state.sh - 321}/>

        {/* Grass Mid */}
        <TilingSprite texture={this.props.texture[1]}
                      width={this.state.sw}
                      height={ 279 }
                      scale={[1,1]}
                      alpha={1}
                      anchor={[0,0]}
                      x={0}
                      y={this.state.sh - 279}/>

        {/* Grass Near */}
        <TilingSprite texture={this.props.texture[0]}
                      width={this.state.sw}
                      height={ 305 }
                      scale={[1,1]}
                      alpha={1}
                      anchor={[0,0]}
                      x={0}
                      y={this.state.sh - 305}/>

      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Layers/Grass.js